import React, { useEffect, useState } from "react";
import logo from "./logo.png";
import "./App.css";
import { styled } from "@mui/material/styles";
import skip from "./skip.png";
import { Button, responsiveFontSizes, TextField } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import Option from "./components/Options";
import RadionButton from "./components/RadioButton";
// const bg = require("./bg.jpeg");
const skipcashBlue = "#1e3f91";

const ColorButton = styled(Button)(({ theme }) => ({
  color: theme.palette.getContrastText(skipcashBlue),
  backgroundColor: skipcashBlue,
  color: "white",
  textTransform: "capitalize",
  fontFamily: "Poppins",

  "&:hover": {
    backgroundColor: "white",
    borderColor: skipcashBlue,
    borderWidth: 1,
    borderStyle: "solid",
    color: skipcashBlue,
    textTransform: "capitalize",
    fontFamily: "Poppins",
  },
}));

function App() {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );
  const [name, setName] = useState({
    value: "",
    err: false,
    errTxt: "",
  });
  const [option, setOption] = useState({ value: "", err: false, errTxt: "" });
  const [phone, setPhone] = useState({ value: "", err: false, errTxt: "" });
  const [email, setEmail] = useState({ value: "", err: false, errTxt: "" });
  const [amount, setAmount] = useState({ value: "", err: false, errTxt: "" });
  const options = [
    "A-STATE",
    "Other",
  ];

  const [clicked, setClicked] = useState(false);
  const [calculated, setCalculated] = useState(false);
  const [showNote, setShowNote] = useState(false);
  const [totalAmount, setTotalAmount] = useState(0);
  const [flag, setFlag] = useState(false);
  const [program, setProgram] = useState({ value: "", err: false, errTxt: "" });
  const [otherProgram, setOtherProgram] = useState({
    value: "",
    err: false,
    errTxt: "",
  });
  const [currentClass, setCurrentClass] = useState({
    value: "",
    err: false,
    errTxt: "",
  });

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleData = (value, field, index) => {
    if (field === "name") setName({ value, err: false, errTxt: "" });
    else if (field === "phone") setPhone({ value, err: false, errTxt: "" });
    else if (field === "email") setEmail({ value, err: false, errTxt: "" });
    else if (field === "otherProgram")
      setOtherProgram({ value, err: false, errTxt: "" });
    else if (field === "amount") setAmount({ value, err: false, errTxt: "" });
    else if (field === "program") {
      setProgram({ value, err: false, errTxt: "" });
    } else console.log("All good");
  };
  const validateEmail = (email) => {
    return /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g.test(email);
  };
  const pay = async () => {
    setClicked(true);
    const nameRegEx = /^[A-Za-z ]+$/;
    const numRegEx = new RegExp("^[0-9]*$");
    if (name.value === "") {
      setName({
        value: "",
        err: true,
        errTxt: " Name cannot be empty",
      });
      setClicked(false);

      return;
    }
    if (!nameRegEx.test(name.value)) {
      setName({
        value: "",
        err: true,
        errTxt: " Name can only have English Letters",
      });
      setClicked(false);
      return;
    }
    if (program.value === "") {
      setProgram({
        value: "",
        err: true,
        errTxt: " Program cannot be empty",
      });
      setClicked(false);

      return;
    }
    // if (!nameRegEx.test(grade.value)) {
    //   setGrade({
    //     value: "",
    //     err: true,
    //     errTxt: " Grade can only have English Letters",
    //   });
    //   setClicked(false);
    //   return;
    // }

    if (phone.value === "") {
      setPhone({
        value: "",
        err: true,
        errTxt: "Phone Number cannot be empty",
      });
      setClicked(false);
      return;
    }
    if (!numRegEx.test(phone.value)) {
      setPhone({
        value: "",
        err: true,
        errTxt: "Invalid Phone Number",
      });
      setClicked(false);
      return;
    }

    if (email.value === "") {
      setEmail({ value: "", err: true, errTxt: "Email cannot be empty" });
      setClicked(false);
      return;
    }
    if (program.value === "Other") {
      if (otherProgram.value === "") {
        setOtherProgram({
          value: "",
          err: true,
          errTxt: "Program cannot be empty",
        });
        setClicked(false);
        return;
      }
      if (!nameRegEx.test(otherProgram.value)) {
        setOtherProgram({
          value: "",
          err: true,
          errTxt: " Program can only have English Letters",
        });
        setClicked(false);
        return;
      }
    }

    if (!validateEmail(email.value)) {
      setEmail({
        value: "",
        err: true,
        errTxt: "Invalid Email",
      });
      setClicked(false);
      return;
    }
    if (amount.value === "") {
      setAmount({ value: "", err: true, errTxt: "Amount cannot be empty" });
      setClicked(false);
      return;
    }
    if (!numRegEx.test(amount.value)) {
      setAmount({
        value: "",
        err: true,
        errTxt: "Invalid Amount",
      });
      setClicked(false);
      return;
    }

    // alert(amount.value);

    // if (recieve === "") {
    //   alert("Missing or Invalid Details");
    //   setClicked(false);

    //   return;
    // }
    if (amount.value > 60000) {
      alert("Total Amount Should Be Less than 60000");
      setClicked(false);

      return;
    }

    const url = "https://valley-forge.herokuapp.com/pay";
    // const url = "http://localhost:4000/pay";

    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        name: name.value,
        program:
          program.value === "Other"
            ? `Other - ${otherProgram.value}`
            : program.value,
        phoneNumber: phone.value,
        email: email.value,
        amount: amount.value,
        schoolname: "GSI",
      }),
    });
    const json = await response.json();

    window.location = json.payUrl;
  };

  // useEffect(() => {
  //   calculateTotal();
  // }, [flag]);

  // const calculateTotal = () => {
  //   let total = 0;
  //   setCalculated(true);
  //   if (delivery) total = total + 40;
  //   setTotalAmount(total);
  // };
  const handleChange = (value) => {
    let tempTotal = totalAmount;
    let test = tempTotal % 150 == 0;
    if (value === "Delivery") {
      tempTotal = tempTotal + 40;
      setShowNote(false);
    } else if (value === "Pickup" && !test) {
      tempTotal = tempTotal - 40;
      setShowNote(true);
    } else {
      setShowNote(true);
    }
    setTotalAmount(tempTotal);
  };

  const styles = {
    container: {
      backgroundColor: "#242424",
      width: "100%",
      // height: "100%",
      height: "auto",
      margin: 0,
      display: "flex",
      overflow: "hidden",
      flex: 1,
      flexDirection: "column",
      minHeight: "100%",
    },
    whiteContainer: {
      display: "flex",
      justifyContent: "center",
      paddingTop: "5%",
      paddingBottom: "5%",
      // height: "100%",sz
      height: "auto",
    },
    mobileButton: {
      width: "100%",
      padding: "5%",
      borderRadius: 10,
      fontStyle: "Quicksand",
      fontSize: "1em",
      height: 40,
    },
    desktopButton: {
      width: "100%",
      padding: "2%",
      borderRadius: 10,
      fontStyle: "Quicksand",
      fontSize: "1.2em",
      height: 20,
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.whiteContainer}>
        <div
          style={{
            borderWidth: 1,
            borderStyle: "solid",
            borderColor: "transparent",
            borderRadius: 10,
            width: "90%",
            background: "white",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img src={logo} style={{ height: windowDimensions.height / 5 }} />
          </div>

          <div
            style={{
              fontFamily: "Poppins",
              marginLeft: "5%",
              marginRight: "5%",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <h3>A-STATE Qatar PayMe Checkout</h3>
            </div>

            <div
              style={{
                marginTop: "1%",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <TextField
                fullWidth
                label="Student Name"
                id="fullWidth"
                onChange={(e) => handleData(e.target.value, "name")}
                error={name.err}
                helperText={name.errTxt}
                type="text"
              />
            </div>
            <div
              style={{
                marginTop: "1%",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Option
                categories={options}
                handleData={handleData}
                label={"Program"}
                fontStyle={styles.fontSizeStyle}
                field={"program"}
                fullWidth
                style={{ width: "48%" }}
              />
            </div>
            {program.value === "Other" ? (
              <div
                style={{
                  marginTop: "1%",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <TextField
                  fullWidth
                  label="Program"
                  id="fullWidth"
                  onChange={(e) => handleData(e.target.value, "otherProgram")}
                  error={otherProgram.err}
                  helperText={otherProgram.errTxt}
                  type="text"
                />
              </div>
            ) : null}
            <div
              style={{
                marginTop: "1%",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <TextField
                fullWidth
                label="Phone Number"
                id="fullWidth"
                onChange={(e) => handleData(e.target.value, "phone")}
                error={phone.err}
                helperText={phone.errTxt}
                type="number"
              />
            </div>
            <div
              style={{
                marginTop: "1%",
              }}
            >
              <TextField
                fullWidth
                label="Email"
                id="fullWidth"
                onChange={(e) => handleData(e.target.value, "email")}
                error={email.err}
                helperText={email.errTxt}
                type="email"
              />
            </div>
            <div
              style={{
                marginTop: "1%",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <TextField
                fullWidth
                label="Amount"
                id="fullWidth"
                onChange={(e) => handleData(e.target.value, "amount")}
                error={amount.err}
                helperText={amount.errTxt}
                type="text"
              />
            </div>

            {/* New code */}

            {/* <h5>Would you like to :</h5>
            <RadionButton dcategory={dcategory} handleChange={handleChange} />
            {showNote && (
              <h6 style={{ color: "red" }}>
                Note: Please collect it from the studio
              </h6>
            )} */}
            <div
              style={{
                marginTop: "1.5%",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <h3
                style={{
                  fontStyle: "Quicksand",
                  fontSize: "1.1em",
                  opacity: 0.3,
                }}
              >
                Total
              </h3>
              <h3
                style={{
                  fontStyle: "Quicksand",
                  fontSize: "1.1em",
                  // opacity: 0.3,
                }}
              >
                {`${amount.value} QAR`}
              </h3>
            </div>
          </div>

          <div
            style={{
              // height: windowDimensions.height / 3,
              display: "flex",
              flex: 1,
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div style={{ width: "90%", padding: "2%" }}>
              {clicked ? (
                <LoadingButton
                  loading
                  variant="outlined"
                  style={
                    windowDimensions.width < 1000
                      ? styles.mobileButton
                      : styles.desktopButton
                  }
                >
                  SUBMIT
                </LoadingButton>
              ) : (
                <ColorButton
                  onClick={() => pay()}
                  style={
                    windowDimensions.width < 1000
                      ? styles.mobileButton
                      : styles.desktopButton
                  }
                >
                  Proceed to Pay
                </ColorButton>
              )}
            </div>

            {/* <h1>hello</h1> */}
          </div>
          <div
            style={{
              // padding: "5%",
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-end",
            }}
          >
            <img
              src={skip}
              style={
                windowDimensions.width < 1000
                  ? { height: windowDimensions.width / 8 }
                  : { height: windowDimensions.width / 25 }
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
